// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1H1a5","cell":"ColumnAccessor_cell__1TWYB","firstCellAccent":"ColumnAccessor_firstCellAccent__2uGVQ"};